/** Per-world vignette registry: later worlds add one import + one line. Vignettes belong to picture drawings only. */
import type { PathId } from '@sketchling/core';
import { ANIMALS_VIGNETTES } from '../worlds/animals/vignettes';
import { ANIME_VIGNETTES } from '../worlds/anime/vignettes';
import { CHARACTERS_VIGNETTES } from '../worlds/characters/vignettes';
import { CUTE_VIGNETTES } from '../worlds/cuteObjects/vignettes';
import { INTRO_VIGNETTES } from '../worlds/intro/vignettes';
import { NATURE_VIGNETTES } from '../worlds/nature/vignettes';
import type { VignetteSpec, WorldVignettes } from './types';

export const VIGNETTE_WORLDS: WorldVignettes[] = [INTRO_VIGNETTES, ANIMALS_VIGNETTES, NATURE_VIGNETTES, CHARACTERS_VIGNETTES, ANIME_VIGNETTES, CUTE_VIGNETTES];

const byId = new Map<string, VignetteSpec & { world: PathId }>();
for (const w of VIGNETTE_WORLDS) for (const s of w.specs) byId.set(s.id, { ...s, world: w.world });

/** The vignette of a picture (map node `mu-<id>`, activity id or drawing id); undefined = plain figure. */
export function vignetteFor(q: { activityId?: string; drawingId?: string }): (VignetteSpec & { world: PathId }) | undefined {
  const a = q.activityId?.replace(/^mu-/, '');
  return (a ? byId.get(a) : undefined) ?? (q.drawingId ? byId.get(q.drawingId) : undefined);
}

export const vignetteUrl = (s: { world: PathId; bg: string }) => `/vignettes/${s.world}/${s.bg}.webp`;
